import Antd from "ant-design-vue";
export const antd = Antd;
export default antd;
